import * as React from 'react';

// tslint:disable:max-line-length
export const PreloaderIcon = () => (
  <svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>Preloader</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M16,30 C23.7319865,30 30,23.7319865 30,16 C30,8.2680135 23.7319865,2 16,2 C8.2680135,2 2,8.2680135 2,16"
        stroke="#2B87DB"
        strokeWidth="4"
        transform="translate(16.000000, 16.000000) rotate(-124.000000) translate(-16.000000, -16.000000) "
      ></path>
    </g>
  </svg>
);
